import {switchWithAutoCompleteFieldConfigConstructor} from "scenes/cohort-filters/filter-configs/fieldContructors";
import {Category} from "scenes/cohort-filters/filter-configs/categories";

export const arthroseFields = {
    ...switchWithAutoCompleteFieldConfigConstructor({
        category: Category.ARTHROSE,
        pathToSelectValues: "anamnesis.haveArthroseData.values.value",
        pathToSwitchQuestion: "anamnesis.haveArthrose",
        autocompleteLabel: "anamnesis.arthrose.which-joint",
        fieldLabel: "anamnesis.arthrose.title",
    }),
}
